import axios from "axios";
import { getCsrfHeaders } from "./csrf";

export default axios.create({
  timeout: 7000,
  headers: getCsrfHeaders(),
});
